import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { api } from "@/lib/api";

export default function CookieBanner() {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const stored = localStorage.getItem(`cookie_consent_${lang}`);
    if (!stored) setOpen(true);
  }, [lang]);
  useEffect(() => {
    api.get("/site-settings").then(r => setSettings(r.data)).catch(() => setSettings(null));
  }, []);
  const set = (v) => { localStorage.setItem(`cookie_consent_${lang}`, v); setOpen(false); };
  const cb = settings?.cookie_banner;
  if (!open || (cb && cb.show === false)) return null;
  const T = (obj) => (obj && (obj[lang] || obj.en || obj.da)) || "";
  const message = T(cb?.text) || t("cookie_msg");
  const essential = T(cb?.essential_label) || t("cookie_essential");
  const accept = T(cb?.accept_label) || t("cookie_accept");
  const policyUrl = cb?.policy_url || "/legal/cookies";
  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 md:bottom-4 md:right-4 md:max-w-md z-50 mx-auto md:mx-0 bg-ink text-base p-6 shadow-xl border border-line/20">
      <p className="text-sm leading-relaxed mb-4">{message}</p>
      <div className="flex gap-2">
        <button data-testid="cookie-essential" onClick={() => set("essential")}
                className="text-xs tracking-wide px-4 py-2 border border-base/40 hover:bg-base/10 transition-colors">
          {essential}
        </button>
        <button data-testid="cookie-accept" onClick={() => set("all")}
                className="text-xs tracking-wide px-4 py-2 bg-terracotta hover:bg-terracotta-dark transition-colors">
          {accept}
        </button>
        <Link to={policyUrl} data-testid="cookie-policy-link"
              className="text-xs tracking-wide px-4 py-2 underline text-base/70 hover:text-base">
          {lang === "es" ? "Leer más" : lang === "da" ? "Læs mere" : "Read more"}
        </Link>
      </div>
    </div>
  );
}
